// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"icon-wrapper--qUwaD","cloud-download-icon":"cloud-download-icon--E2VV7"};